import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DetailedCitation from './DetailedCitation';

class CitationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      citation: props.citation,
      show: false,
    };

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleShow() {
    this.setState({ show: true, });
  }

  handleClose() {
    this.setState({ show: false, });
  }

  sendNavigationRequest() {
    return null;
  }

  render() {
    const { show, } = this.state;
    const { citation, } = this.state;
    return (
      <>
        <Button variant="primary" onClick={this.handleShow}>
          Details
        </Button>

        <Modal show={show} onHide={this.handleClose} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              Citation Id&nbsp;
              {citation.citationLookup.citationId}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(() => {
              if (show) {
                return <DetailedCitation citation={citation} />;
              }
              return undefined;
            })()}
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </>
    );
  }
}

CitationModal.propTypes = {
  citation: PropTypes.instanceOf(Object).isRequired,
};

export default CitationModal;
